import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-[var(--fpn-navy)] text-white mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-14 grid grid-cols-2 md:grid-cols-4 gap-8">
        <div className="col-span-2">
          <div className="font-display text-2xl font-bold">Park<span className="text-[var(--fpn-amber)]">pot</span></div>
          <p className="text-slate-300 mt-3 max-w-md text-sm leading-relaxed">
            One search. Every way to park at the airport. Compare official parking, Park & Ride, Meet & Greet and approved community spaces at every major UK airport.
          </p>
        </div>
        <div>
          <div className="text-sm font-semibold mb-3 text-white">Company</div>
          <ul className="text-sm text-slate-300 space-y-2">
            <li><Link to="/legal">Terms</Link></li>
            <li><Link to="/legal">Privacy</Link></li>
            <li><Link to="/legal">Host Terms</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-sm font-semibold mb-3 text-white">For Hosts</div>
          <ul className="text-sm text-slate-300 space-y-2">
            <li><Link to="/host">Become a Host</Link></li>
            <li><Link to="/host">Host Dashboard</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-6 text-center text-xs text-slate-400">
        © {new Date().getFullYear()} Parkpot Ltd · parkpot.com
      </div>
    </footer>
  );
}
